import React from "react";
import {
  Card,
  Grid,
  Typography,
} from "@mui/material";

const LekStaticCurrency = ({colors}) => {
  return (
    <Grid container item md={5} xs={5}>
      <Card
        elevation={0}
        sx={{
          background: colors.cyan,
          height: "45px",
          width: "100%",
        }}
      >
        <Grid
          container
          item
          md={12}
          xs={12}
          justifyContent={"space-around"}
          alignItems={"center"}
          marginTop={1.2}
        >
          <Typography>ALL</Typography>
          <img
            src={
              "https://vectorflags.s3-us-west-2.amazonaws.com/flags/al-circle-01.png"
            }
            alt="flag"
            width={"20px"}
          />
        </Grid>
      </Card>
    </Grid>
  );
};

export default LekStaticCurrency;
